import { DesktopSidebarItemState } from "./DesktopSidebarActions";
import config from "../../config";
import { useState } from "react";
import { useNavigate } from "react-router-dom/dist";
import { Italic } from "lucide-react/dist/lucide-react";
interface SidebarStyleProps {
  desktopSidebarContainer?: React.CSSProperties;
  desktopSidebarSiteName?: React.CSSProperties;
  desktopSidebarButtonStyle?: React.CSSProperties;
  desktopSidebarButtonHoverStyle?: React.CSSProperties;
  desktopSidebarActivePage?: React.CSSProperties;
  desktopSidebarProfileName?: React.CSSProperties;
  desktopSidebarJoinFundraiserText: React.CSSProperties;
  desktopSidebarJoinFundraiserButton: React.CSSProperties;
  desktopSidebarJoinFundraiserBox: React.CSSProperties;
}

interface DesktopSidebarProps {
  profileName: string;
  actions: DesktopSidebarItemState[];
  style?: SidebarStyleProps;
}

// Fully CSS customizable sidebar. Use SidebarStyleProps to change styling
// overriding the default styling it is the callers responsibility to properly define
const DesktopSidebar: React.FC<DesktopSidebarProps> = ({
  profileName,
  actions,
  style,
}) => {
  const [hoveredButton, setHoveredButton] = useState<string | null>(null);
  const navigate = useNavigate();

  const defaultStyle: SidebarStyleProps = {
    desktopSidebarContainer: {
      width: "100%",
      background: "#F2F3FA",
      maxWidth: "400px",
      height: "100%",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyItems: "center",
    },
    desktopSidebarSiteName: {
      textAlign: "left",
      fontStyle: "italic",
      color: "#0066CC",
      fontSize: "20px",
      fontWeight: "600",
    },
    desktopSidebarProfileName: {
      fontWeight: "bolder",
    },
    desktopSidebarButtonStyle: {
      width: "100%",
      borderRadius: "8px",
      height: "45px",
    },
    desktopSidebarButtonHoverStyle: {
      background: "#d0d0d0",
    },
    desktopSidebarActivePage: {
      color: "blue",
    },

    desktopSidebarJoinFundraiserBox: {
      marginTop: "auto",
      width: "100%",
      border: "2px solid #E0E0E0",
      borderRadius: "16px",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "12px",
    },

    desktopSidebarJoinFundraiserText: {
      fontSize: "16px",
      fontWeight: "600",
      textAlign: "center",
    },

    desktopSidebarJoinFundraiserButton: {
      width: "100%",
      background: "#0066CC",
      color: "white",
      border: "none",
      borderRadius: "8px",
      height: "45px",
      fontWeight: "bold",
      cursor: "pointer",
    },
  };

  return (
    <div
      style={
        style && style.desktopSidebarContainer
          ? style.desktopSidebarContainer
          : defaultStyle.desktopSidebarContainer
      }
    >
      <div
        style={
          style && style.desktopSidebarSiteName
            ? style.desktopSidebarSiteName
            : defaultStyle.desktopSidebarSiteName
        }
      >
        {config.SITE_NAME}
      </div>
      <div
        style={
          style && style.desktopSidebarProfileName
            ? style.desktopSidebarProfileName
            : defaultStyle.desktopSidebarProfileName
        }
      >
        Welcome, {profileName}
      </div>
      {actions.map((entry) => (
        <button
          style={{
            ...(style && style.desktopSidebarButtonStyle
              ? style.desktopSidebarButtonStyle
              : defaultStyle.desktopSidebarButtonStyle),
            ...(hoveredButton === entry.action.label &&
              (style && style.desktopSidebarButtonHoverStyle
                ? style.desktopSidebarButtonHoverStyle
                : defaultStyle.desktopSidebarButtonHoverStyle)),
            ...(entry.isHighlighted
              ? style && style.desktopSidebarActivePage
                ? style.desktopSidebarActivePage
                : defaultStyle.desktopSidebarActivePage
              : {}),
          }}
          key={entry.action.label}
          onMouseEnter={() => setHoveredButton(entry.action.label)}
          onMouseLeave={() => setHoveredButton(null)}
          onClick={() =>
            entry.action.navigateTo
              ? navigate(entry.action.navigateTo)
              : alert("Navigate to not defined. Please alert website owner")
          }
        >
          {entry.action.icon} {entry.action.label}
        </button>
      ))}
      <div
        style={
          style && style.desktopSidebarJoinFundraiserBox
            ? style.desktopSidebarJoinFundraiserBox
            : defaultStyle.desktopSidebarJoinFundraiserBox
        }
      >
        <div
          style={
            style && style.desktopSidebarJoinFundraiserText
              ? style.desktopSidebarJoinFundraiserText
              : defaultStyle.desktopSidebarJoinFundraiserText
          }
        >
          Join a Fundraiser
        </div>
        <button
          style={
            style && style.desktopSidebarJoinFundraiserButton
              ? style.desktopSidebarJoinFundraiserButton
              : defaultStyle.desktopSidebarJoinFundraiserButton
          }
          onClick={() => navigate("register-or-shop")}
        >
          Join Now
        </button>
      </div>
    </div>
  );
};

export default DesktopSidebar;
